<template>
  <md-table-row :md-item="productList" class="align-left">
    <md-table-cell>{{ productList.customId }}</md-table-cell>
    <md-table-cell>{{ productList.name }}</md-table-cell>
    <md-table-cell>
      <span id="num-of-products" :class="{'not-usable': productList.products.length === 0}">{{ productList.products.length }}</span>
    </md-table-cell>

    <md-dialog md-open-from="#delete-product-list" md-close-to="#delete-product-list" ref="dialog">
      <md-dialog-title><translate>Are you sure you want to delete product list:</translate></md-dialog-title>
      <md-dialog-content>
        <md-layout md-align="center"><span class="md-headline">{{ productList.name }}</span></md-layout>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button id="close-dialog" class="md-default" @click.native="closeDialog('dialog')"><translate>Cancel</translate></md-button>
        <md-button id="confirm-dialog" class="md-raised md-accent" @click.native="confirmDialog('dialog')"><translate>Delete</translate></md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-table-cell class="cell-icon-container">
      <md-button @click.native="clickEdit(productList)" class="md-icon-button">
        <md-icon class="cell-icon">edit</md-icon>
      </md-button>
    </md-table-cell>
    <md-table-cell class="cell-icon-container">
      <md-button id="delete-product-list" @click.native="openDialog('dialog')" class="md-icon-button">
        <md-icon class="cell-icon">delete</md-icon>
      </md-button>
    </md-table-cell>
  </md-table-row>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'product-list-row',
  props: [ 'productList' ],
  computed: {
  },
  methods: {
    ...mapMutations([
      'productListEdit',
      'productListToDelete',
      'productListCancelDelete'
    ]),
    openDialog (ref) {
      this.$refs[ref].open()
      this.productListToDelete(this.productList)
    },
    closeDialog (ref) {
      this.$refs[ref].close()
      this.productListCancelDelete()
    },
    confirmDialog (ref) {
      this.$refs[ref].close()
      this.$store.dispatch('deleteProductLists')
    },
    clickEdit (productList) {
      this.$router.push({ name: 'tab-3-edit', params: { id: productList._id } })
      this.productListEdit(productList._id)
    }
  }
}
</script>

<style>
/*
Defined in users/Row.vue
.delete-icon
.edit-icon
.align-left
*/
</style>



// WEBPACK FOOTER //
// src/components/admin/product-lists/Row.vue